"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["innerHTML"];
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'LoadPage',
    props: {
        url: {},
        query: {}
    },
    emits: ["load", "unload"],
    setup(__props, { emit: __emit }) {
        const html = (0, vue_3.ref)();
        const props = __props;
        const url = (0, vue_3.computed)(() => { var _a; return props.url + ((_a = props.query) !== null && _a !== void 0 ? _a : ''); });
        const emit = __emit;
        (0, vue_3.watch)(url, () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            emit('unload');
            yield (0, vue_3.nextTick)();
            html.value = yield fetch(url.value, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': (_b = (_a = document.querySelector('meta[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) !== null && _b !== void 0 ? _b : '',
                },
            }).then((r) => r.text());
            yield (0, vue_3.nextTick)();
            emit('load');
        }), { immediate: true });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                innerHTML: html.value,
                style: { "display": "contents" }
            }, null, 8, _hoisted_1));
        };
    }
});
